<template>
  <div v-if="enableBanner" id="banner" refs="banner" :class="[{'visible': isVisible}]">
    <div class="content">
      <div class="txt">
        <p>
          <b>{{$t('label.bannerText1')}}</b>
          {{` - ${$t('label.bannerText2', { date: releaseDate, time: releaseTime, approximateHours })}`}}
        </p>

        <p>{{$t('label.bannerText3', { productName })}} <a v-if="['', null].indexOf(learnMoreURL) < 0" :href="learnMoreURL" target="_blank" class="learn-more">{{$t('label.learnMore')}}</a></p>
      </div>
    </div>

    <div @click="handleCloseBanner" class="close-icon">
      <el-icon><Close /></el-icon>
    </div>
  </div>
</template>

<script src="./banner.js"></script>
<style lang="scss" src="./banner.scss"></style>
